import React from 'react';
import './ContactUs.scss';
import { Helmet } from "react-helmet";

function ContactUs() {
  return (
    <div className='contact-us'>
      <Helmet>
        <title>Artifit - Contact us</title>
        <meta name="description" content="How to contact Artifit company" />
      </Helmet>

      <h2 className='contact-action'>The right technology changes everything.<br />Let's find yours.</h2>

      <a href="mailto:office@artifit.rs" rel="noreferrer" target="_blank">
        <button className='contact-button'>Get in touch</button>
      </a>
    </div>
  );
}

export default ContactUs;
